<template>
  <footer class="text-center text-white">
    <div class="container p-4"></div>
    <div class="text-center p-3 copyright">
      <a class="text-white" href="https://github.com/echobinod">@echobinod</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
footer {
  background-color: #21081a;
}
.copyright {
  background-color: rgba(0, 0, 0, 0.2);
}
</style>